
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/o-firme",
      function () {
        return require("private-next-pages/o-firme.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/o-firme"])
      });
    }
  